<template>
  <v-dialog
    v-model="internalValue"
    max-width="520"
    persistent
  >
    <v-card>
      <!-- HEADER -->
      <v-card-title class="text-h6 font-weight-bold">
        Simulación de liquidación: {{ credit.folio }}
      </v-card-title>

      <v-divider />

      <!-- BODY -->
      <v-card-text>

        <div class="mb-4 grey--text text--darken-1">
          Selecciona la fecha en la que deseas liquidar el crédito.
          El sistema calculará el monto total considerando capital, intereses, I.V.A. y moratorios.
        </div>

        <!-- FECHA -->
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="settlementDateFormatted"
              label="Fecha de liquidación"
              outlined
              dense
              readonly
              v-bind="attrs"
              v-on="on"
            />
          </template>

          <v-date-picker
            v-model="settlementDate"
            :min="minDate"
            @input="menu = false"
          />
        </v-menu>

        <!-- RESULTADO -->
        <template v-if="result">
          <v-divider class="my-4" />

          <div class="text-subtitle-1 font-weight-bold mb-2">
            Resultado de la simulación
          </div>

          <div class="simulation-row">
            <span>Capital</span>
            <span>{{ formatCurrency(result.capital) }}</span>
          </div>

          <div class="simulation-row">
            <span>Intereses</span>
            <span>{{ formatCurrency(result.interestAtDay) }}</span>
          </div>

          <div class="simulation-row">
            <span>I.V.A.</span>
            <span>{{ formatCurrency(result.interestAtDayIva) }}</span>
          </div>

          <div class="simulation-row">
            <span>Moratorios</span>
            <span>{{ formatCurrency(result.moratoriumAtDay) }}</span>
          </div>

          <v-divider class="my-2" />

          <div class="simulation-row total">
            <span>Total a liquidar</span>
            <span>{{ formatCurrency(result.toLiquidate) }}</span>
          </div>
        </template>

      </v-card-text>

      <!-- ACTIONS -->
      <v-card-actions class="justify-end">
        <v-btn
          text
          @click="close"
        >
          Cerrar
        </v-btn>

        <v-btn
          color="primary"
          :disabled="!settlementDate"
          :loading="loading"
          @click="simulate"
        >
          Simular liquidación
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment'
import productMixin from '../../mixins/productMixin'
import CreditsManagerService from '../../services/CreditsManagerService'

export default {
  name: 'SimulateSettlementModal',

  mixins: [productMixin],

  props: {
    value: {
      type: Boolean,
      default: false
    },
    credit: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      internalValue: this.value,
      settlementDate: null,
      menu: false,
      loading: false,
      result: null
    }
  },

  watch: {
    value (val) {
      this.internalValue = val
    },
    internalValue (val) {
      this.$emit('input', val)
    }
  },

  methods: {
    close () {
      this.internalValue = false
      this.reset()
    },

    reset () {
      this.settlementDate = null
      this.result = null
      this.loading = false
    },

    async simulate () {
      this.loading = true

      try {
        const { currentBalance } = await CreditsManagerService.getCreditBalance({
          id: this.credit.id,
          date: this.settlementDate,
          applyFuturePayments: true

        })

        this.result = currentBalance.balance
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error(error)
        this.$emit('error', error)
      }
    }
  },

  computed: {
    minDate () {
      return moment().format('YYYY-MM-DD')
    },
    settlementDateFormatted () {
      return this.formatDateShortText(this.settlementDate)
    }
  }
}
</script>

<style scoped>
.simulation-row {
  display: flex;
  justify-content: space-between;
  margin: 6px 0;
}

.simulation-row.total {
  font-weight: bold;
  font-size: 1.05rem;
}
</style>
